import React from "react";

/** Microsoft's four-square logo (brand colors are fixed by Microsoft, not theme tokens). */
const MicrosoftLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0" y="0" width="9.5" height="9.5" fill="#F25022"/>
    <rect x="10.5" y="0" width="9.5" height="9.5" fill="#7FBA00"/>
    <rect x="0" y="10.5" width="9.5" height="9.5" fill="#00A4EF"/>
    <rect x="10.5" y="10.5" width="9.5" height="9.5" fill="#FFB900"/>
  </svg>
);

export default MicrosoftLogo;
